import { DiagnosticFunnel } from '../../../components/tools/DiagnosticFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('coproprietes', 'diagnostic-cee')!;

export default function CoproprieteDiagnosticCeePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/coproprietes"
        backLabel="Espace copropriétés"
        duration="3 min"
      >
        <DiagnosticFunnel lockedAudience="coproprietes" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace copropriétés', url: 'https://solutionecofrance.fr/coproprietes' },
          { name: 'Diagnostic CEE copropriété', url: 'https://solutionecofrance.fr/coproprietes/diagnostic-cee' },
        ]}
      />
    </>
  );
}
